import { render, staticRenderFns } from "./MultiStepFormDecision.vue?vue&type=template&id=1f31e2d8&scoped=true&"
import script from "./MultiStepFormDecision.vue?vue&type=script&lang=js&"
export * from "./MultiStepFormDecision.vue?vue&type=script&lang=js&"
import style0 from "./MultiStepFormDecision.vue?vue&type=style&index=0&id=1f31e2d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f31e2d8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VSelect,VTextField})
